export default {
  root: {
    borderRadius: 5
  },
};
